/**
 * Brand assets and signature constants for Nove Zero Due.
 */
export const BRAND_NAME = "Nove Zero Due";
export const BRAND_TAGLINE = "Restaurant & More";
export const LOGO_URL = "/logo-nove-zero-due.png";
export const CREDIT_LINE = "Created by Ferdinando Guzzo Consulting · 2026";
